import React, { useState } from "react";
import "./textAreaWithCount.css";

const TextAreaWithCount = ({
  label = "",
  maxChars = 2000,
  placeholder = "Type your text here...",
  value = "",
  onChange,
  ...props
}) => {
  return (
    <div className="textarea-with-count-container">
      {/* Optional label */}
      {label && <label className="textarea-label">{label}</label>}

      <textarea
        className="textarea-with-count"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        // If you want to strictly enforce max length in the UI:
        maxLength={maxChars}
        {...props}
      />

      {/* Character count display */}
      <div className="char-count">
        {value.length}/{maxChars}
      </div>
    </div>
  );
};

export default TextAreaWithCount;
